<script setup lang="ts">
import BasicStepper from "../basic/BasicStepper.vue";
import BackButton from "../buttons/BackButton.vue";
import NextButton from "../buttons/NextButton.vue";

type INextFunction = () => void;
type IProps = {
  title?: string;
  subtitle?: string;
  heading?: string;
  maxSteps?: number;
  currentStep?: number;
  next?: string | Object | INextFunction;
  back?: string | Object | INextFunction;
  isAllowedNext?: boolean;
}
const props = withDefaults(defineProps<IProps>(), {
  currentStep: 1,
  maxSteps: 1
});

</script>

<template>
  <div
    class="w-full md:w-[1200px] py-6 md:py-[77px] bg-[var(--m-light)] text-[var(--m-dark)] px-0 md:px-[264px] rounded-tr-lg rounded-br-lg shadow relative">
    <div class="flex flex-col items-center gap-5">
      <div class="flex flex-col items-center gap-8 px-4 md:px-0">
        <div class="flex flex-col items-center gap-3">
          <h1 class="font-['Sora'] font-bold text-4xl" v-if="props.title">{{ props.title }}</h1>
          <h2 class="text-sm" v-if="props.subtitle">{{ props.subtitle }}</h2>
        </div>
        <BasicStepper :current-step="props.currentStep" :max-steps="props.maxSteps" />
        <div v-if="props.heading"
             class="flex items-center gap-1 text-[var(--m-primary-base)] font-['Sora'] font-bold text-2xl w-full">
          <div
            class="flex-auto w-8 border-t-2 transition duration-500 ease-in-out border-[var(--m-primary-base)]"></div>
          {{ props.heading.toUpperCase() }}
          <div
            class="flex-auto w-8 border-t-2 transition duration-500 ease-in-out border-[var(--m-primary-base)]"></div>
        </div>

      </div>

      <slot name="content">
        <div class="flex flex-col gap-12 w-full">
          <slot />
        </div>
      </slot>

      <div class="w-full flex gap-4 justify-end px-4 md:px-0">
        <BackButton v-if="typeof props.back === 'function'" @click.prevent="() => props.back && (props.back as INextFunction)()" />
        <BackButton
          v-if="typeof props.back === 'string' || typeof props.back === 'object'"
          :to="props.back" />
        <NextButton
          v-if="typeof props.next === 'function'"
          @click.prevent="() => props.next && (props.next as INextFunction)()"
          :disabled="!props.isAllowedNext"
        />
        <NextButton
          v-if="typeof props.next === 'string' || typeof props.next === 'object'"
          :to="props.next"
          :disabled="!props.isAllowedNext"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
